<template>
    <div>
        <navView @handleCommand="handleCommand" />
        <div class="wrap">
            <div class="product-box">
                <div class="product-left" v-if="activeIndex == 1">
                    <div class="product-img">
                        <img src="../assets/images/product/img01.jpg" style="transform: scale(2);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product01') }}</h3>
                        <div class="product-sub-title">{{ $t('product.subTitle01') }}</div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 2">
                    <div class="product-img">
                        <img src="../assets/images/product/img02.jpg" style="transform: scale(1.2);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product02') }}</h3>
                        <div class="product-sub-title">{{ $t('product.subTitle02') }}</div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 3">
                    <div class="product-img">
                        <img src="../assets/images/product/img03.png" style="transform: scale(1.6);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product03') }}</h3>
                        <div class="product-sub-title">{{ $t('product.subTitle03') }}</div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 4">
                    <div class="product-img">
                        <img src="../assets/images/product/img04.jpg" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product04') }}</h3>
                        <div class="product-sub-title">{{ $t('product.subTitle04') }}</div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 5">
                    <div class="product-img">
                        <img src="../assets/images/product/img05.jpg" style="transform: scale(1.8);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product05') }}</h3>
                        <div class="product-sub-title"></div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 6">
                    <div class="product-img">
                        <img src="../assets/images/product/img06.jpg" style="transform: scale(1.6);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product06') }}</h3>
                        <div class="product-sub-title"></div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 7">
                    <div class="product-img">
                        <img src="../assets/images/product/img07.jpg" style="transform: scale(1.1);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product07') }}</h3>
                        <div class="product-sub-title"></div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 8">
                    <div class="product-img">
                        <img src="../assets/images/product/img08.jpg" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product08') }}</h3>
                        <div class="product-sub-title"></div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 9">
                    <div class="product-img">
                        <img src="../assets/images/product/img09.jpg" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product09') }}</h3>
                        <div class="product-sub-title">{{ $t('product.subTitle09') }}</div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 10">
                    <div class="product-img">
                        <img src="../assets/images/product/img10.jpg" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product10') }}</h3>
                        <div class="product-sub-title">{{ $t('product.subTitle10') }}</div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 11">
                    <div class="product-img">
                        <img src="../assets/images/product/img11.jpg" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product11') }}</h3>
                        <div class="product-sub-title">{{ $t('product.subTitle11') }}</div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 12">
                    <div class="product-img">
                        <img src="../assets/images/product/img12.png" style="transform: scale(1.2);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product12') }}</h3>
                        <div class="product-sub-title"></div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 13">
                    <div class="product-img">
                        <img src="../assets/images/product/img13.jpg" style="transform: scale(1.2);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product13') }}</h3>
                        <div class="product-sub-title"></div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 14">
                    <div class="product-img">
                        <img src="../assets/images/product/img14.png" style="transform: scale(1.6);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product14') }}</h3>
                        <div class="product-sub-title"></div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 15">
                    <div class="product-img">
                        <img src="../assets/images/product/img15.png" style="transform: scale(2);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product15') }}</h3>
                        <div class="product-sub-title"></div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 16">
                    <div class="product-img">
                        <img src="../assets/images/product/img16.jpg" style="transform: scale(1.5);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product16') }}</h3>
                        <div class="product-sub-title"></div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 17">
                    <div class="product-img">
                        <img src="../assets/images/product/img17.png" style="transform: scale(1.5);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product17') }}</h3>
                        <div class="product-sub-title"></div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 18">
                    <div class="product-img">
                        <img src="../assets/images/product/img18.png" style="transform: scale(1.5);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product18') }}</h3>
                        <div class="product-sub-title"></div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 19">
                    <div class="product-img">
                        <img src="../assets/images/product/img19.png" style="transform: scale(1.5);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product19') }}</h3>
                        <div class="product-sub-title"></div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 20">
                    <div class="product-img">
                        <img src="../assets/images/product/img20.png" style="transform: scale(1.5);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product20') }}</h3>
                        <div class="product-sub-title"></div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-left" v-if="activeIndex == 21">
                    <div class="product-img">
                        <img src="../assets/images/product/img21.png" style="transform: scale(1.5);" alt="">
                    </div>
                    <div class="product-content">
                        <h3>{{ $t('from.product21') }}</h3>
                        <div class="product-sub-title"></div>
                        <el-button type="primary" class="product-btn" @click="handleUs">{{ $t('from.contact') }}</el-button>
                    </div>
                </div>
                <div class="product-right">
                    <span class="title">
                        <div class="span"></div>
                        <h3>{{ $t('from.newProduct') }}</h3>
                    </span>
                    <ul>
                        <li>
                            <a href="http://www.yimi-tech.net/upload/20220708143448.jpg">
                                <p>{{ $t('from.product01') }}</p>
                            </a>
                        </li>
                        <li>
                            <a href="http://www.yimi-tech.net/upload/20220708144423.jpg">
                                <p>{{ $t('from.product02') }}</p>
                            </a>
                        </li>
                        <li>
                            <a href="http://www.yimi-tech.net/upload/20220708145530.png">
                                <p>{{ $t('from.product03') }}</p>
                            </a>
                        </li>
                        <li>
                            <a href="http://www.yimi-tech.net/upload/20210916151337.jpg">
                                <p>{{ $t('from.product04') }}</p>
                            </a>
                        </li>
                        <li>
                            <a href="	http://www.yimi-tech.net/upload/20220708152146.jpg">
                                <p>CPU</p>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="product-illustrate">
                <span class="title" style="margin-bottom:20px">
                    <div class="span"></div>
                    <h3>{{ $t('from.illustrate') }}</h3>
                </span>
                <div class="product-show" v-if="activeIndex == 1">
                    <p>{{ $t('product.indexP101') }}</p>
                    <p>{{ $t('product.indexP201') }}</p>
                    <div class="spec">{{ $t('from.spec') }}</div>
                    <myTable :tableData="tableData1" />
                </div>
                <div class="product-show" v-if="activeIndex == 2">
                    <p>{{ $t('product.indexP102') }}</p>
                    <p>{{ $t('product.indexP202') }}</p>
                    <div class="spec">{{ $t('from.spec') }}</div>
                    <myTable :tableData="tableData2" />
                </div>
                <div class="product-show" v-if="activeIndex == 3">
                    <p>{{ $t('product.indexP103') }}</p>
                    <p>{{ $t('product.indexP203') }}</p>
                    <div class="spec">{{ $t('from.spec') }}</div>
                    <myTable :tableData="tableData3" />
                </div>
                <div class="product-show" v-if="activeIndex == 4">
                    <p>{{ $t('product.indexP104') }}</p>
                    <p>{{ $t('product.indexP204') }}</p>
                    <div class="spec">{{ $t('from.spec') }}</div>
                    <myTable :tableData="tableData4" />
                </div>
                <div class="product-show" v-if="activeIndex == 5">
                    <myTableRow :tableData="tableData5" />
                </div>
                <div class="product-show" v-if="activeIndex == 6">
                    <myTableRow :tableData="tableData6" />
                </div>
                <div class="product-show" v-if="activeIndex == 8">
                    <div style="line-height:32px;font-size:16px" v-for="item in tableData8" :key="index">{{ item.title }}
                    </div>
                </div>
                <div class="product-show" v-if="activeIndex == 9">
                    <div style="line-height:32px;font-size:16px" v-for="item in tableData9" :key="index">{{ item.title }}
                    </div>
                </div>
                <div class="product-show" v-if="activeIndex == 10">
                    <div style="line-height:32px;font-size:16px" v-for="item in tableData10" :key="index">{{ item.title }}
                    </div>
                </div>
                <div class="product-show" v-if="activeIndex == 11">
                    <div style="line-height:32px;font-size:16px" v-for="item in tableData11" :key="index">{{ item.title }}
                    </div>
                </div>
                <div class="product-show" v-if="activeIndex == 12">
                    <div style="line-height:32px;font-size:16px" v-for="item in tableData12" :key="index">{{ item.title }}
                    </div>
                </div>
            </div>
            <div class="p-btn">
                <div @click="handlePre">{{ $t('footer.pre1') }} <span v-if="activeIndex == 1">{{ $t('footer.no')
                }}</span><span v-else>{{ $t('footer.pre2') }}</span></div>
                <div @click="handleNext">{{ $t('footer.next1') }} <span v-if="activeIndex == 21">{{ $t('footer.no')
                }}</span><span v-else>{{ $t('footer.next2') }}</span></div>
            </div>
        </div>
        <footerView />
    </div>
</template>
  
<script>
import navView from '@/components/nav.vue'
import footerView from '@/components/footer.vue'
import myTable from '@/components/table.vue'
import myTableRow from '@/components/tableRow.vue'
export default {
    name: 'MyComponent',
    components: {
        navView, footerView, myTable, myTableRow
    },
    data() {
        return {
            pathDocx: '',
            isLoading: true,
            activeIndex: 0,
            tableData1: [],
            tableData2: [],
            tableData3: [],
            tableData4: [],
            tableData5: [
                { "code": "0231ACKB ", "pCode": "UN-CPU-INTEL-3204-2U-M", "describe": "H3C   UniServer R4900/R2900 G3 3204(1.9GHz/6核/8.25MB/85W)CPU模块(FIO)" }, { "code": "0231AEL2 ", "pCode": "UN-CPU-INTEL-3206R-2Ua-M", "describe": "H3C UniServer R4900/R2900 G3   3206R(1.9GHz/8核/11MB/85W)CPU模块(CMCTO)" }, { "code": "0231ACJX ", "pCode": "UN-CPU-INTEL-4208-2U-M", "describe": "H3C UniServer R4900/R2900 G3   4208(2.1GHz/8核/11MB/85W)CPU模块(FIO)" }, { "code": "0231ACKE ", "pCode": "UN-CPU-INTEL-4210-2U-M", "describe": "H3C UniServer R4900/R2900 G3   4210(2.2GHz/10核/13.75MB/85W)CPU模块(FIO)" }, { "code": "0231AEKN ", "pCode": "UN-CPU-INTEL-4210R-2Ua-M", "describe": "H3C UniServer R4900/R2900 G3   4210R(2.4GHz/10核/13.75MB/100W)CPU模块(CMCTO)" }, { "code": "0231ACK3 ", "pCode": "UN-CPU-INTEL-4214-2U-M", "describe": "H3C UniServer R4900/R2900 G3   4214(2.2GHz/12核/16.5MB/85W)CPU模块(FIO)" }, { "code": "0231AEEP ", "pCode": "UN-CPU-INTEL-4214R-2Ua-M", "describe": "H3C UniServer R4900/R2900 G3   4214R(2.4GHz/12核/16.5MB/100W)CPU模块(CMCTO)" }, { "code": "0231AD7F ", "pCode": "UN-CPU-INTEL-4214Y-2U-M", "describe": "H3C UniServer R4900 G3   4214Y(2.2GHz/12核/16.5MB/85W)CPU模块(CMCTO)" }, { "code": "0231ACK4 ", "pCode": "UN-CPU-INTEL-4215-2U-M", "describe": "H3C UniServer R4900/R2900 G3   4215(2.5GHz/8核/11MB/85W)CPU模块(FIO)" }, { "code": "0231AEKQ ", "pCode": "UN-CPU-INTEL-4215R-2Ub-M", "describe": "H3C UniServer R4900 G3   4215R(3.2GHz/8核/11MB/130W)CPU模块(CMCTO)" }, { "code": "0231ACJY  ", "pCode": "UN-CPU-INTEL-4216-2U-M", "describe": "H3C UniServer R4900/R2900 G3   4216(2.1GHz/16核/22MB/100W)CPU模块(FIO)" }, { "code": "0231AD5V ", "pCode": "UN-CPU-INTEL-5215-2U-M", "describe": "H3C UniServer R4900 G3   5215(2.5GHz/10核/13.75MB/85W)CPU模块(CMCTO)" }, { "code": "0231AD6Q ", "pCode": "UN-CPU-INTEL-5217-2U-M", "describe": "H3C UniServer R4900/R2900 G3   5217(3.0GHz/8核/11MB/115W)CPU模块(CMCTO)" }, { "code": "0231AC5H ", "pCode": "UN-CPU-5218-2U-M", "describe": "H3C UniServer R4900/R2900 G3   5218(2.3GHz/16核/22MB/125W) CPU模块(FIO)" }, { "code": "0231AD6R ", "pCode": "UN-CPU-INTEL-5218N-2U-M", "describe": "H3C UniServer R4900/R2900 G3   5218N(2.3GHz/16核/22MB/110W)CPU模块(CMCTO)" }, { "code": "0231AEEH ", "pCode": "UN-CPU-INTEL-5218R-2Ua-M", "describe": "H3C UniServer R4900/R2900 G3   5218R(2.1GHz/20核/27.5MB/125W)CPU模块(CMCTO)" }, { "code": "0231ABDK ", "pCode": "UN-CPU-5220-2U-F", "describe": "H3C UniServer R4900/R2900 G3   5220(2.2GHz/18核/24.75MB/125W) CPU模块(FIO)" }, { "code": "0231AEKC  ", "pCode": "UN-CPU-INTEL-5220R-2Ub-M", "describe": "H3C UniServer R4900 G3   5220R(2.2GHz/24核/35.75MB/150W)CPU模块(CMCTO)" }, { "code": "0231AD65 ", "pCode": "UN-CPU-INTEL-5220S-2U-M", "describe": "H3C UniServer R4900/R2900 G3   5220S(2.7GHz/18核/24.75MB/125W)CPU模块(CMCTO)" }, { "code": "0231ACKQ ", "pCode": "UN-CPU-INTEL-5222-2U-M", "describe": "H3C UniServer R4900/R2900 G3   5222(3.8GHz/4核/16.5MB/105W)CPU模块(FIO)" }, { "code": "0231AD5J  ", "pCode": "UN-CPU-INTEL-6226-2U-M", "describe": "H3C UniServer R4900/R2900 G3   6226(2.7GHz/12核/19.25MB/125W)CPU模块(CMCTO)" }, { "code": "0231AEN7 ", "pCode": "UN-CPU-INTEL-6226R-2Ub-M", "describe": "H3C UniServer R4900 G3   6226R(2.9GHz/16核/22MB/150W)CPU模块(CMCTO)" }, { "code": "0231ABDX ", "pCode": "UN-CPU-6230-2U-F", "describe": "H3C UniServer R4900/R2900 G3   6230(2.1GHz/20核/27.5MB/125W) CPU模块(FIO)" }, { "code": "0231AD6X ", "pCode": "UN-CPU-INTEL-6230N-2U-M", "describe": "H3C UniServer R4900/R2900 G3   6230N(2.3GHz/20核/27.5MB/125W)CPU模块(CMCTO)" }, { "code": "0231AEEC  ", "pCode": "UN-CPU-INTEL-6230R-2Ub-M", "describe": "H3C UniServer R4900 G3   6230R(2.1GHz/26核/35.75MB/150W)CPU模块(CMCTO)" }, { "code": "0231AD61 ", "pCode": "UN-CPU-INTEL-6234-2U-M", "describe": "H3C UniServer R4900 G3   6234(3.3GHz/8核/24.75MB/130W)CPU模块(CMCTO)" }, { "code": "0231AD6T ", "pCode": "UN-CPU-INTEL-6238-2U-M", "describe": "H3C UniServer R4900 G3   6238(2.1GHz/22核/30.25MB/140W)CPU模块(CMCTO)" }, { "code": "0231AEMS ", "pCode": "UN-CPU-INTEL-6238R-2Ub-M", "describe": "H3C UniServer R4900 G3   6238R(2.2GHz/28核/38.5MB/165W)CPU模块(CMCTO)" }, { "code": "0231ABDR ", "pCode": "UN-CPU-6240-2U-F", "describe": "H3C UniServer R4900 G3   6240(2.6GHz/18核/24.75MB/150W) CPU模块(FIO)" }, { "code": "0231AEN4 ", "pCode": "UN-CPU-INTEL-6240R-2Ub-M", "describe": "H3C UniServer R4900 G3   6240R(2.4GHz/24核/35.75MB/165W)CPU模块(CMCTO)" }, { "code": "0231ABDS ", "pCode": "UN-CPU-6242-2U-F", "describe": "H3C UniServer R4900 G3   6242(2.8GHz/16核/22MB/150W) CPU模块(FIO)" }, { "code": "0231AENN ", "pCode": "UN-CPU-INTEL-6242R-2Ub-M", "describe": "H3C UniServer R4900 G3   6242R(3.1GHz/20核/35.75MB/205W)CPU模块(CMCTO)" }, { "code": "0231AC6J  ", "pCode": "UN-CPU-6244-2U-M", "describe": "H3C UniServer R4900 G3   6244(3.6GHz/8核/24.75MB/150W) CPU模块(FIO)" }, { "code": "0231AD7N ", "pCode": "UN-CPU-INTEL-6246-2U-M", "describe": "H3C UniServer R4900 G3   6246(3.3GHz/12核/24.75MB/165W)CPU模块(CMCTO)" }, { "code": "0231AENP ", "pCode": "UN-CPU-INTEL-6246R-2Ub-M", "describe": "H3C UniServer R4900 G3   6246R(3.4GHz/16核/35.75MB/205W)CPU模块(CMCTO)" }, { "code": "0231ABDJ  ", "pCode": "UN-CPU-6248-2U-F", "describe": "H3C UniServer R4900 G3   6248(2.5GHz/20核/27.5MB/150W) CPU模块(FIO)" }, { "code": "0231AEEB  ", "pCode": "UN-CPU-INTEL-6248R-2Ub-M", "describe": "H3C UniServer R4900 G3   6248R(3.0GHz/24核/35.75MB/205W)CPU模块(CMCTO)" }, { "code": "0231AD5R  ", "pCode": "UN-CPU-INTEL-6252-2U-M", "describe": "H3C UniServer R4900 G3   6252(2.1GHz/24核/33MB/150W) CPU模块(CMCTO)" }, { "code": "0231ADYB  ", "pCode": "UN-CPU-INTEL-6252N-2Ub-M", "describe": "H3C UniServer R4900 G3   6252N(2.3GHz/24核/35.75MB/150W)CPU模块(CMCTO)" }, { "code": "0231AC4K  ", "pCode": "UN-CPU-6254-2U-M", "describe": "H3C UniServer R4900 G3   6254(3.1GHz/18核/24.75MB/200W) CPU模块(FIO)" }, { "code": "0231AENV ", "pCode": "UN-CPU-INTEL-6258R-2Ub-M", "describe": "H3C UniServer R4900 G3   6258R(2.7GHz/28核/38.5MB/205W)CPU模块(CMCTO)" }, { "code": "0231AD6L  ", "pCode": "UN-CPU-INTEL-8253-2U-M", "describe": "H3C UniServer R4900/R2900 G3   8253(2.2GHz/16核/22MB/125W)CPU模块(CMCTO)" }, { "code": "0231AD86  ", "pCode": "UN-CPU-INTEL-8256-2U-M", "describe": "H3C UniServer R4900/R2900 G3   8256(3.8GHz/4核/16.5MB/105W)CPU模块(CMCTO)" }, { "code": "0231ABE1  ", "pCode": "UN-CPU-8260-2U-F", "describe": "H3C UniServer R4900 G3   8260(2.4GHz/24核/35.75MB/165W) CPU模块(FIO)" }, { "code": "0231AD7A ", "pCode": "UN-CPU-INTEL-8260Y-2U-M", "describe": "H3C UniServer R4900 G3   8260Y(2.4GHz/24核/35.75MB/165W)CPU模块(CMCTO)" }, { "code": "0231ACKC ", "pCode": "UN-CPU-INTEL-8268-2U-M", "describe": "H3C UniServer R4900 G3   8268(2.9GHz/24核/35.75MB/205W)CPU模块(FIO)" }, { "code": "0231ACKD ", "pCode": "UN-CPU-INTEL-8270-2U-M", "describe": "H3C UniServer R4900 G3   8270(2.70GHz/26核/35.75MB/205W)CPU模块(FIO)" }, { "code": "0231AC5J  ", "pCode": "UN-CPU-8276-2U-M", "describe": "H3C UniServer R4900 G3   8276(2.2GHz/28核/38.5MB/165W) CPU模块(FIO)" }, { "code": "0231AD5U ", "pCode": "UN-CPU-INTEL-8280-2U-M", "describe": "H3C UniServer R4900 G3   8280(2.7GHz/28核/38.5MB/205W)CPU模块(CMCTO)" }, { "code": "0231AC9P  ", "pCode": "UN-CPU-JINTIDE-C1450-2U-M", "describe": "H3C UniServer R4900/R2900 G3   C1450(2.2GHz/14核/19.25MB/105W)CPU模块(FIO)" }, { "code": "0231AFBX  ", "pCode": "UN-CPU-MONTAGE-C4215R-2Ub-M", "describe": "H3C UniServer R4900 G3   C4215R(3.2GHz/8Cores/11MB/130W)CPU Module(CMCTO)" }, { "code": "0231AFBK  ", "pCode": "UN-CPU-MONTAGE-C5218R-2Ua-M", "describe": "H3C UniServer R4900 G3   C5218R(2.1GHz/20核/27.5MB/125W)CPU模块(CMCTO)" }, { "code": "0231AFBW ", "pCode": "UN-CPU-MONTAGE-C5220R-2Ub-M", "describe": "H3C UniServer R4900 G3   C5220R(2.2GHz/24核/35.75MB/150W)CPU模块(CMCTO)" }, { "code": "0231AFBN ", "pCode": "UN-CPU-MONTAGE-C6226R-2Ub-M", "describe": "H3C UniServer R4900 G3   C6226R(2.9GHz/16核/22MB/150W)CPU模块(CMCTO)" }, { "code": "0231AFBG ", "pCode": "UN-CPU-MONTAGE-C6230R-2Ub-M", "describe": "H3C UniServer R4900 G3   C6230R(2.1GHz/26核/35.75MB/150W)CPU模块(CMCTO)" }, { "code": "0231AFBL  ", "pCode": "UN-CPU-MONTAGE-C6248R-2Ub-M", "describe": "H3C UniServer R4900 G3   C6248R(3.0GHz/24核/35.75MB/205W)CPU模块(CMCTO)" }
            ],
            tableData6: [
                { "code": "0231ABDT ", "pCode": "UN-DDR4-2933P-16G-2Rx8-R-F", "describe": "16GB   2Rx8 DDR4-2933P-R内存模块(FIO)" }, { "code": "0231ABE2 ", "pCode": "UN-DDR4-2933P-16G-1Rx4-R-F", "describe": "16GB 1Rx4   DDR4-2933P-R内存模块(FIO)" }, { "code": "0231ABDU ", "pCode": "UN-DDR4-2933P-32G-2Rx4-R-F", "describe": "32GB 2Rx4   DDR4-2933P-R内存模块(FIO)" }, { "code": "0231AEXC ", "pCode": "UN-DDR4-2933-32G-2Rx8-R-M", "describe": "32GB 2Rx8 DDR4-2933   CAS-21-21-21 RDIMM内存模块(CMCTO)" }, { "code": "0231AC4L  ", "pCode": "UN-DDR4-2933P-64G-2Rx4-R-F", "describe": "64GB 2Rx4   DDR4-2933P-R内存模块(FIO)" }, { "code": "0231AF6R  ", "pCode": "UN-DDR4-3200AA-16G-2Rx8-R", "describe": "16GB 2Rx8 DDR4-3200   CAS-22-22-22 RDIMM内存模块(CTO&BTO)" }, { "code": "0231AF76  ", "pCode": "UN-DDR4-3200AA-32G-2Rx4-R", "describe": "32GB 2Rx4 DDR4-3200   CAS-22-22-22 RDIMM内存模块(CTO&BTO)" }, { "code": "0231AG95  ", "pCode": "UN-DDR4-3200AA-32G-2Rx8-R", "describe": "32GB 2Rx8 DDR4-3200   CAS-22-22-22 RDIMM内存模块(CTO&BTO)" }, { "code": "0231AF6K  ", "pCode": "UN-DDR4-3200AA-64G-2Rx4-R", "describe": "64GB 2Rx4 DDR4-3200   CAS-22-22-22 RDIMM内存模块(CTO&BTO)" }
            ],
            tableData8: [],
            tableData9: [],
            tableData10: [],
            tableData11: [],
            tableData12: [],
        };
    },
    created() {
        console.log(this.$route.query.index)
        this.activeIndex = this.$route.query.index
        if (window.sessionStorage.getItem('language') == 'en') {
            this.$i18n.locale = 'en'
            this.onEnList()
        } else {
            this.$i18n.locale = 'zh'
            this.onZhList()
        }
        scrollTo(0, 0)
    },
    methods: {
        handleCommand(name) {
            if (name == 'en') {
                this.$i18n.locale = 'en'
                this.onEnList()
            } else {
                this.$i18n.locale = 'zh'
                this.onZhList()
            }
        },

        handleUs() {
            this.$router.push({ name: 'contact' })
        },
        handlePre() {
            if (this.activeIndex != 1) {
                this.activeIndex--
                console.log(this.$i18n.locale)
                if (this.$i18n.locale == 'en') {
                    this.$i18n.locale = 'en'
                    this.onEnList()
                } else {
                    this.$i18n.locale = 'zh'
                    this.onZhList()
                }
            }
        },
        handleNext() {
            if (this.activeIndex != 17) {
                this.activeIndex++
                if (this.$i18n.locale == 'en') {
                    this.$i18n.locale = 'en'
                    this.onEnList()
                } else {
                    this.$i18n.locale = 'zh'
                    this.onZhList()
                }
            }
        },
        onEnList() {
            if (this.activeIndex == 1) {
                this.tableData1 = [
                    { title: 'processor', content: 'Supports up to 2 Intel chips ® xeon  ® Third generation scalable processor or LANQIJIN ® Processor series, up to 40 cores per chip, with a maximum power of 270W' },
                    { title: 'chipset', content: 'Intel ®  C621A' },
                    { title: 'Memory', content: 'Supports up to 32 DDR4 memory, with a maximum speed of 3200MT/s, supports RDIMM or LRDIMM, and a maximum capacity of 6TB per processor, supporting up to 16 Intel processors ® Aoteng ® Persistent Memory PMem 200 Series' },
                    { title: 'Memory Controller', content: 'Standard onboard array controller, supporting SATA RAID 0/1/10/5, optional HBA card and array card based on standard PCIe slots' },
                    { title: 'FBWC', content: 'Optional support for up to 8GB cache and support for supercapacitor protection' },
                    { title: 'storage', content: 'Supports up to 41 hard drives (37 2.5-inch hard drives, 4 3.5-inch hard drives), up to 20 3.5-inch hard drives (12 front end, 4 internal expansion, 4 rear expansion), and 4 2.5-inch hard drives (rear expansion), up to 37 2.5-inch hard drives (25 front end, 8 internal expansion, 4 rear expansion), and supports SAS/SATA HDD/SSD hard drives; Supports front/built-in NVMe hard drives, supports up to 32 NVMe hard drive slots, supports PCIe NVMe storage accelerator cards, supports SATA and PCIe M.2 options, and supports 2 Micro SD card kits' },
                    { title: 'network', content: '1 1Gbps dedicated management network port on board, optional up to 2 OCP 3.0 network cards, optional expansion 4 × 1GE port or 2 × 10GE electrical/optical port or 2 × 25GE optical port optional network adapter based on standard PCIe slot, supporting 1/10/25/40/100/200 GE network card, IB card' },
                    { title: 'Expansion Slots', content: 'Supports up to 14 PCIe 4.0 standard slots and 1 OCP 3.0 slot (PCIe 4.0 rate)' },
                    { title: 'interface', content: 'Standard configuration includes 1 front VGA, 1 rear VGA, 1 serial port, 6 USB 3.0 (2 front, 2 rear, 2 built-in), and 1 dedicated front management interface' },
                    { title: 'GPU support', content: 'Supports up to 4 dual width GPU cards or 14 single width GPU cards' },
                    { title: 'CD drive', content: 'Support for external optical drive' },
                    { title: 'manage', content: 'HDM agentless management tool (with independent management port) and H3C iFIST/FIST management software, supporting LCD touchable intelligent management module, supporting 64M local graphics memory, optional U-Center data center management platform' },
                    { title: 'safety', content: 'Supports secure chassis, TCM/TPM security module, dual factor authentication' },
                    { title: 'Power and Thermal', content: 'Optional platinum grade 550W/800W/850W/1200W/1300W/1600W/2000W 1+1 redundant power supply, optional titanium grade power supply, optional 800W negative 48V/336V DC power module, supporting 1+1 redundancy and hot swappable redundant fans' },
                    { title: 'authentication', content: 'Support CCC, SEPA, and other certifications' },
                    { title: 'operation temperature', content: '5 ℃ - 45 ℃ (the operating temperature is affected by different configurations, please refer to the detailed product technical documentation for details)' },
                    { title: 'shape', content: '2U chassis' },
                    { title: 'Chassis size', content: '87.5mm (H) * 445.4mm (W) * 748mm (D) (excluding safety panel) 87.5mm (H) * 445.4mm (W) * 776mm (D) (including safety panel)' },
                    { title: 'maintenance', content: '3 years 5 × 9. Next Business Day Response (NBD)' },
                ]
            } else if (this.activeIndex == 2) {
                this.tableData2 = [
                    { title: 'processor', content: 'Supports up to 2 Intel chips ® xeon  ® Scalable family processor or Lanqi Jinzhu ® Processor series, up to 28 cores per chip, with a maximum power of 205W' },
                    { title: 'chipset', content: 'Intel ® C622' },
                    { title: 'Memory', content: 'Supports up to 24 DDR4 memory slots, with a maximum speed of 2933MT/s, supports RDIMM or LRDIMM, and a maximum capacity of 3TB  per processor Supports up to 12 Intel ® Aoteng ™ Data center level persistent memory (DCPMM)' },
                    { title: 'Memory Controller', content: 'Standard onboard array controller, supports SATA RAID 0/1/10/5, optional HBA card based on dedicated slot for array card, supports SATA/SAS RAID 0/1/10, optional array card based on dedicated slot for array card, supports RAID0/1/10/5/6/50/60/1E, optional HBA card and array card based on standard PCIe slot' },
                    { title: 'FBWC', content: 'Optional support for up to 8GB cache and support for supercapacitor protection' },
                    { title: 'storage', content: 'Supports up to 20 3.5-inch hard drives, 4 2.5-inch hard drives (12 front, 4 internal expansion, 8 rear expansion), supports up to 37 2.5-inch hard drives, 3 3.5-inch hard drives (25 front, 8 internal expansion, 7 rear expansion), supports SAS/SATA HDD/SSD hard drives, supports front/built-in NVMe hard drives, supports up to 32 NVMe hard drive slots, supports SATA M.2 option' },
                    { title: 'network', content: 'One 1Gbps management network port on board with optional mLOM extension 4 × 1GE port or 2 × 10GE electrical/optical port optional network adapter based on standard PCIe slot' },
                    { title: 'Expansion Slots', content: 'Up to 10 PCIe 3.0 available slots (including 1 array card dedicated slot and 1 network card dedicated slot)' },
                    { title: 'interface', content: 'Optional front VGA, standard rear VGA and serial port, 5 USB 3.0 (1 front, 2 rear, 2 built-in), optional 1 USB 2.0 and 2 Micro SD card kits' },
                    { title: 'GPU support', content: 'Supports up to 3 dual width GPU cards or 8 single width GPU cards' },
                    { title: 'CD drive', content: 'Supports external optical drive, some models support built-in optical drive' },
                    { title: 'manage', content: 'HDM agentless management tool (with independent management port) and H3C FIST management software, supporting 16M local graphics memory' },
                    { title: 'safety', content: 'Supports chassis intrusion detection, TCM/TPM security module, optional PCIe protection module, providing firewall, IPS, antivirus, and QoS protection functions' },
                    { title: 'Power and Thermal', content: 'Optional platinum level 550W/800W/850W/1200W/1600W 1+1 redundant power supply, optional titanium level 1+1 redundant power supply, optional 800W negative 48V/336V DC power module, supporting 1+1 redundancy and hot swappable redundant fans' },
                    { title: 'authentication', content: 'Support CCC, CECP, SEPA, CE, CB and other certifications' },
                    { title: 'operation temperature', content: '5 ℃ - 50 ℃ (the operating temperature is affected by different configurations, please refer to the detailed product technical documentation for details)' },
                    { title: 'shape', content: '2U chassis' },
                    { title: 'Chassis size', content: '87.5mm (H) * 445.4mm (W) * 748mm (D) (excluding safety panel) 87.5mm (H) * 445.4mm (W) * 771mm (D) (including safety panel)' },
                    { title: 'maintenance', content: '3 years 5 × 9. Next Business Day Response (NBD)' },
                ]
            } else if (this.activeIndex == 3) {
                this.tableData3 = [
                    { title: 'processor', content: 'Supports up to 2 Intel chips ® xeon  ® Scalable family processor or Lanqi Jinzhu ® Processor series, up to 28 cores per chip, with a maximum power of 205W' },
                    { title: 'Memory', content: 'Supports up to 24 DDR4 memory, with a maximum speed of 2933MT/s, supports RDIMM or LRDIMM, and a maximum capacity of 3TB per processor' },
                    { title: 'Persistent Memory', content: 'Supports 12 NVDIMM permanent memory with a maximum capacity of 192GB, supports HPE DC permanent memory with a maximum capacity of 6TB' },
                    { title: 'Memory Controller', content: 'Standard onboard array controller, supports SATA RAID 0/1/10/5, supports HPE intelligent storage SR100i, optional HBA card based on dedicated array card slot, supports SATA/SAS RAID 0/1/10/5, optional Smart Array series array card based on dedicated array card slot, supports SATA/SAS RAID0/1/10/5/6/50/60/1 ADM, optional HBA card based on standard PCIe slot, and Smart Array array card supports 4GB FBWC' },
                    { title: 'storage', content: 'On board 4-port Gigabit network adapter/network card optional NC model without onboard network controller optional FlexibleLOM network adapter optional network adapter based on standard PCIe slot' },
                    { title: 'network', content: 'One 1Gbps management network port on board with optional mLOM extension 4 × 1GE port or 2 × 10GE electrical/optical port optional network adapter based on standard PCIe slot' },
                    { title: 'Expansion Slots', content: 'Standard configuration with 3 available PCIe 3.0 slots, supporting up to 8 available PCIe 3.0 slots' },
                    { title: 'interface', content: 'Optional front VGA and serial port, standard rear VGA 5 USB 3.0 (1 front, 2 rear, 2 built-in), optional 2 Micro SD cards' },
                    { title: 'GPU support', content: 'Up to 7 single width GPU cards or 3 double width GPU cards' },
                    { title: 'CD drive', content: 'Support for external optical drive; Some models support built-in optical drive' },
                    { title: 'manage', content: 'Standard iLO Standard Edition, available in iLO Advanced Edition and OneView Advanced Edition' },
                    { title: 'Power and Thermal', content: 'Optional 500W/800W/1600W 1+1 hot swappable redundant power supply, supports up to 96% titanium, and can support 6 hot swappable redundant fans' },
                    { title: 'operation temperature', content: '5℃ - 45℃,ASHRAE A3 & A4' },
                    { title: 'Chassis size', content: '87.3mm (H) x 445.4mm (W) x 679.4mm (D) (2.5-inch hard drive models) 87.3mm (H) x 445.4mm (W) x 730.2mm (D) (3.5-inch hard drive models)' },
                    { title: 'maintenance', content: 'Channel sales pre configured (BTO) models 3 years 5 × Next Business Day Response Project Sales According to Order (CTO) Model 3 Years 7 × twenty-four × 4-hour service, including basic on-site installation services' },
                ]
            } else if (this.activeIndex == 4) {
                this.tableData4 = [
                    { title: 'processor', content: '4 Intel chips ®  xeon  ®  Scalable processor with up to 28 cores and a maximum power of 205W' },
                    { title: 'Memory', content: '48 pieces of HPE DDR4 intelligent memory, with a maximum speed of 2933MT/s, supporting RDIMM or LRDIMM' },
                    { title: 'Persistent Memory', content: 'Supports 24 NVDIMM permanent memory and 24 Intel ® Aoteng ™ Data center level persistent memory (DCPMM)' },
                    { title: 'Memory Controller', content: 'HPE Smart Array S100i or HPE Smart Array Controller, depending on model, supports up to 4GB cache support Raid 0/1 (ADM)/10 (ADM)/5/50/6/6' },
                    { title: 'storage', content: 'Supports up to 48 SFF hard drives, supports SATA/SAS/SSD, including support for 20 NVMe SSD hard drives' },
                    { title: 'network', content: 'The optional FlexibleLOM supports 1Gb/10Gb/25Gb, and the optional PCIe network card can support up to 100Gb networks' },
                    { title: 'Expansion Slots', content: 'Up to 16 full height PCIe slots, supporting 4 dual width GPUs' },
                    { title: 'interface', content: '9 USB ports (5 3.0, 4 2.0, 2 optional), 2 video ports (1 optional), 1 serial port, 1 MicroSD, supporting dual MicroSD components' },
                    { title: 'fan', content: '12 (11+1) Hot swappable redundancy standard' },
                    { title: 'power supply', content: 'Up to 4 HPE flexible slot power supplies support 240VDC high-voltage DC, depending on the model' },
                    { title: 'environment', content: 'ASHRAE A3 and A4 (limited configuration), standard support for 10 ℃~35 ℃, A3: 5~40 ℃; A4: 5~45 ℃' },
                    { title: 'shape(W x D x H)', content: '44.55×75.18×17.48cm' },
                    { title: 'weight', content: 'Full configuration up to 51.71kg' },
                    { title: 'manage', content: 'Standard iLO Standard Edition, available in iLO Advanced Edition and OneView Advanced Edition' },
                    { title: 'maintenance', content: 'Channel sales pre configured (BTO) models 3 years 5 × Next Business Day Response Project Sales According to Order (CTO) Model 3 Years 7 × twenty-four × 4-hour service, including basic on-site installation services' },
                ]
            } else if (this.activeIndex == 8) {
                this.tableData8 = [{
                    "title": "hard disk   P07924-B21-X HPE 480GB SATA MU LFF SC DS SSD"
                },
                {
                    "title": "hard disk   P07928-B21-X HPE 960GB SATA MU LFF SCC DS SSD"
                },
                {
                    "title": "hard disk   P09691-B21-X HPE 960GB SATA RI LFF LPC DS SSD"
                },
                {
                    "title": "hard disk   P09687-B21-X HPE 480GB SATA RI LFF SCC DS SSD"
                },
                {
                    "title": "hard disk   P09687-B21-大单拆机 HPE 480GB SATA RI LFF SCC DS SSD"
                },
                {
                    "title": "hard disk   P19974-B21-X HPE 480GB SATA RI LFF LPC SSD Ssd(G10 PLUS)"
                },
                {
                    "title": "hard disk   P09685-B21-X HPE 240GB SATA RI SFF RW DS SSD"
                },
                {
                    "title": "hard disk   P47810-B21-X HPE 480GB SATA RI SFF SC PM893 SSD Ssd"
                },
                {
                    "title": "hard disk P47811-B21-X HPE 960GB SATA RI SFF SC PM893 SSD Ssd"
                },
                {
                    "title": "hard disk   P04560-B21-X HPE 480GB SATA RI SFF SC DS SSD"
                },
                {
                    "title": "hard disk   P04564-B21-X HPE 960GB SATA RI SFF SC DS SSD"
                },
                {
                    "title": "hard disk   P18422-B21-X HPE 480GB SATA RI SFF SC MV SSD"
                },
                {
                    "title": "hard disk   P18424-B21-X HPE 960GB SATA RI SFF SC MV SSD"
                },
                {
                    "title": "hard disk   P06200-B21-X HPE 3.84TB SATA RI SFF SC DS SSD(SK Chip)"
                },
                {
                    "title": "HP hard disk   P04570-B21 HPE 3.84TB SATA 6G RI SFF (2.5in) SC DS SSD"
                },
                {
                    "title": "hard disk   P13660-B21-X HPE 960GB SATA MU SFF SC DS SSD"
                },
                {
                    "title": "hard disk P18434-B21-X HPE 960GB SATA MU SFF SC MV SSD"
                },
                {
                    "title": "hard disk   P18432-B21-X HPE 480GB SATA MU SFF SC MV SSD"
                },
                {
                    "title": "hard disk P36997-B21-X HPE 960GB SAS RI SFF SC VS MV SSD"
                },
                {
                    "title": "hard disk P19905-B21-X HPE 1.92TB SAS RI SFF SC SSD"
                },
                {
                    "title": "hard disk   P37001-B21-X HPE 3.84TB SAS RI SFF SC VS MV SSD Ssd"
                },
                {
                    "title": "hard disk   P19907-B21-X HPE 3.84TB SAS RI SFF SC SSD"
                },
                {
                    "title": "hard disk   P37003-B21-X-大单选件 HPE 7.68TB SAS RI SFF SC VC MV SSD"
                },
                {
                    "title": "hard disk   P21125-B21-X HPE 400GB SAS WI SFF SC SSD"
                },
                {
                    "title": "hard disk P21127-B21-X HPE 800GB SAS WI SFF SC SSD"
                },
                {
                    "title": "hard disk   P21127-B21-C HPE 800GB SAS WI SFF SC SSD"
                },
                {
                    "title": "hard disk   P09102-B21-X HPE 1.6TB SAS WI SFF SC DS SSD"
                },
                {
                    "title": "hard disk   P37005-B21-X HPE 960GB SAS MU SFF SC VS MV SSD Ssd"
                },
                {
                    "title": "hard disk   P21133-B21-X HPE 1.6TB SAS MU SFF SC SSD"
                },
                {
                    "title": "hard disk   P19913-B21-C HPE 800GB SAS MU SFF SC SSD"
                },
                {
                    "title": "hard disk P26934-B21-X HPE 1.6TB NVME MU HH PM1735 SSD(PCI-E)"
                },
                {
                    "title": "hard disk   P19915-B21-大单盒包 HPE 1.6TB SAS MU SFF SC SSD"
                },
                {
                    "title": "hard disk   P13668-B21-X HPE 800GB NVME X4 MU SFF SCN DS SSD"
                },
                {
                    "title": "hard disk   P13670-B21-X HPE 1.6TB NVME X4 MU SFF SCN DS SSD"
                },
                {
                    "title": "hard disk P40554-B21-X HPE 1.92TB SATA VRO SFF BC 5210 SSD固态硬盘(G10 PLUS)"
                },
                {
                    "title": "hard disk   P44007-B21-X HPE 480GB SATA RI SFF BC PM893 SSD Ssd(G10 PLUS)"
                },
                {
                    "title": "hard disk P44008-B21-X HPE 960GB SATA RI SFF BC PM893 SSD Ssd(G10 PLUS)"
                }]
            } else if (this.activeIndex == 9) {
                this.tableData9 = [{
                    "title": "Application Acceleration"
                },
                {
                    "title": "The performance of H3C UniStor CF2000 exceeds 200000 IOPS, and user application acceleration costs are within an affordable range."
                },
                {
                    "title": "No experience requirement"
                },
                {
                    "title": "The H3C UniStor CF2000 is easy to install, use, and maintain, without the need for storage expertise. Automatic layering can dynamically respond to changes in workload, so there is no need for manual intervention"
                },
                {
                    "title": "Maintain business operations through extended data protection capabilities"
                },
                {
                    "title": "New virtualization snapshot technology makes data protection and instant recovery possible."
                },
                {
                    "title": "Use FC or iSCSI for remote replication, reducing disaster recovery costs."
                },
                {
                    "title": "Enable flexible growth now and in the future"
                },
                {
                    "title": "Data in situ upgrades protect drive investments and reduce the risk of data migration."
                },
                {
                    "title": "Customers can leverage any combination of SSD, enterprise grade, or Midline SAS drives to begin miniaturization and scale deployment."
                }]
            } else if (this.activeIndex == 10) {
                this.tableData10 = [{
                    "title": "new function"
                },
                {
                    "title": "• Support the deduplication function of flash media, further improving the utilization efficiency of storage capacity"
                },
                {
                    "title": "• SmartSAN functionality supports automated configuration of SAN Zoning, eliminating the need to configure SAN Zoning in advance before configuring hosts and volumes, automatically discovering and creating SAN Zoning managed by storage target ports"
                },
                {
                    "title": "• Supports three data center storage level disaster recovery technologies for entry-level, enterprise, and high-end enterprise products in the same series, with each controller equipped with one IP disaster recovery replication interface. Disaster recovery technology can be combined with thin configuration and asynchronous snapshot technology to reduce link replication costs. The latest version can also support a unified management of SAN and NAS dual activity+three center disaster recovery solution"
                },
                {
                    "title": "• Supports fine-grained QoS control, allowing for IOPS, bandwidth, and latency settings for each volume, ensuring predictable service levels for your applications, workloads, and tenants. The application latency can be controlled to be less than 0.5ms"
                },
                {
                    "title": "Advanced architecture makes H3C CF series storage stand out"
                },
                {
                    "title": "The high-performance and automatic optimization provided by the three-layer virtualization architecture can easily meet the mixed load requirements of cloud computing, virtualization, and data center integration in enterprise level data centers. It can be extended from two controllers to multiple controllers, with PCI-E bus interconnection between controllers providing horizontal and vertical 3D scaling, supporting over 32TB of cache, optimizing IO performance, and reducing access latency. The controller engine is completely physically independent of each other, and all core components such as processors/cache/front-end cards/back-end cards of the controller engine are completely private and independent. Under the same architecture, it integrates SAN, NAS, and Object Storage to meet various access needs. The architecture optimized for flash memory achieves the integration of flash drives and mechanical hard drives, provides optimization for flash data access, and also provides flash memory two-level adaptive caching and automatic data layering functions."
                },
                {
                    "title": "High availability features allow users to rest assured"
                },
                {
                    "title": "Up to 99.9999% high availability, T10-PI end-to-end data consistency verification, four control cache retention function, cross disk enclosure RAID for cage level security, cloning, snapshot, remote replication software, and integrated backup function for further data protection"
                },
                {
                    "title": "Simple and efficient, reducing overall user costs"
                },
                {
                    "title": "Thin provisioning and deduplication capabilities can reduce user capacity by up to 75%. Graphical management interface and reporting functions, SAN network automatic configuration, quick installation wizard, and intelligent automatic optimization functions can reduce user management time by up to 90%"
                },
                {
                    "title": "Provide all enterprise level storage capabilities"
                },
                {
                    "title": "It not only provides the functions of cloning, snapshot and remote data replication of traditional enterprise storage, but also provides VMWare VAAI, VASA integration, Microsoft Hyper-V integration and Open Stack integration for the new generation enterprise data center. It also provides functions such as fast RAID recovery, data optimization software, complete Qos control, storage partition, storage cluster, disaster recovery for three data centers, high availability between arrays, and online data migration"
                },
                {
                    "title": "The H3C CF series Peer Motion function can form a storage federation cluster with H3C CF high-end model storage without additional gateways. Data can be migrated online between multiple storage devices according to performance, capacity and other policies, transparent to the host platform"
                },
                {
                    "title": "Supports cloud backup features, supporting direct backup of data to public or private clouds"
                },
                {
                    "title": "advantage"
                },
                {
                    "title": "1.Integrated storage architecture: SAN, NAS, and Object Storage functions can be simultaneously implemented on one storage device. Different models of H3C CF storage can achieve synchronization and heterogeneous data replication, and different models of CF devices can form a storage federation"
                },
                {
                    "title": "2.CPU+ASIC chip: the advanced 5th generation ASIC chip realizes thin configuration, re deletion, RAID operation and other functions in the way of hardware acceleration, which can easily cope with the mixed IO load in the virtualized environment and cloud computing, so that the transaction intensive and throughput intensive workloads can simultaneously run on the same storage resources without resource contention"
                },
                {
                    "title": "3.True multi control system: Multi controller architecture, with high bandwidth and low latency PCI-E bus point-to-point full mesh direct interconnection between multiple controllers. Multiple controllers can simultaneously access the same LUN space, ensuring that performance increases linearly with the growth of controller data; And in the event of multiple controller failures, it can maintain high-performance operation of storage in the case of multi control"
                },
                {
                    "title": "4.Storage internal underlying virtualization technology: ensures high IO performance of the storage system, prevents the occurrence of hot hard drives, and enables multi to many high-speed reconstruction in the event of hard drive failure. Different RAID types such as RAID0/1/5/6/10/50/60 can exist simultaneously on the same hard drive"
                },
                {
                    "title": "5.High availability: Up to 99.9999% availability, providing T10-PI consistency data detection protection from host HBA ports to storage array hard drives, ensuring data integrity; Simultaneously equipped with data high availability function, providing storage based data copy protection function. When data is written to storage, 2-4 data copies can be created according to policies to protect data security; In addition, the storage system supports data loss and application interruption in the event of power failure or failure of at least one hard disk expansion enclosure, providing an expansion enclosure level data protection mechanism"
                },
                {
                    "title": "6.High applicability: can create no less than 65536 virtual volumes and no less than 16000 host connections, suitable for various existing IT environments"
                },
                {
                    "title": "7.Enterprise level functions: powerful snapshot, clone, thin configuration, re deletion, compression, automatic layering, one key RAID type conversion, storage federation, heterogeneous storage data migration, flash backup data protection solutions, and enterprise level functions such as synchronous and asynchronous disaster recovery, 3DC disaster recovery, dual active, dual active+3DC"
                },
                {
                    "title": "8.Storage Heterogeneous Virtualization Function: Realize the heterogeneous takeover of CF series storage over third-party storage arrays from different vendors, support mainstream storage vendor products, and achieve data migration."
                }]
            } else if (this.activeIndex == 11) {
                this.tableData11 = [
                    {
                        "title": "Distributed fusion architecture"
                    },
                    {
                        "title": "The H3C UniStor X10000 adopts a fully distributed fusion architecture, providing strong guarantees for the high-performance, scalable, secure, reliable, and automated operation and maintenance of storage systems."
                    },
                    {
                        "title": "Supports both block, file, object, and big data storage"
                    },
                    {
                        "title": "Support big data storage function, support components such as Hadoop, Hbase, Hive, Spark, Impala, and support additional write semantics"
                    },
                    {
                        "title": "Distributed symmetric architecture without the need for a separate metadata server"
                    },
                    {
                        "title": "Distributed global caching, effectively improving cluster read and write performance"
                    },
                    {
                        "title": "Supports Intel chip platform and Haiguang chip platform"
                    },
                    {
                        "title": "Open virtual machine architecture, supporting the deployment of vendor self-developed or third-party streaming software within nodes."
                    },
                    {
                        "title": "Powerful linear scalability"
                    },
                    {
                        "title": "Scalable horizontally to 8192 nodes, supporting flexible business development"
                    },
                    {
                        "title": "Performance and capacity grow linearly with node count and cluster size"
                    },
                    {
                        "title": "Reliability"
                    },
                    {
                        "title": "Multiple copies ensure data reliability and support flexible configuration of 2-8 copies. For example, only when three copies of data are lost at the same time can user data be truly lost, ensuring the persistence of data storage"
                    },
                    {
                        "title": "Supports different erasure code levels from N+1 to N+4, which can be set based on resource pools and directories"
                    },
                    {
                        "title": "Comprehensive data protection and disaster recovery capabilities, supporting technologies such as replication, snapshots, clones, copies, fault domains, protection domains, etc"
                    },
                    {
                        "title": "Persistence of data ≥ 99.999999999999% (13 9s)"
                    },
                    {
                        "title": "availability"
                    },
                    {
                        "title": "Fully redundant networking, no single point of failure, no service interruption and no application awareness in case of hard disk or node damage"
                    },
                    {
                        "title": "Automatic reconstruction in case of hard disk or node failure, with adjustable reconstruction priority"
                    },
                    {
                        "title": "Supports online non-stop expansion, adding or deleting nodes and hard drives without affecting normal business operations, and supports automatic data balancing of clusters"
                    },
                    {
                        "title": "Data availability ≥ 99.9995%"
                    },
                    {
                        "title": "Easy maintenance"
                    },
                    {
                        "title": "Rapid deployment of clusters, supporting batch deployment, configuration guidance, and one click upgrade"
                    },
                    {
                        "title": "Relying on the monitoring and alarm system, quickly defining problems and troubleshooting, allowing users to customize data distribution strategies, and supporting fault domain isolation"
                    },
                    {
                        "title": "Manageability"
                    },
                    {
                        "title": "Chinese visual operation management platform, supporting both IPv4 and IPv6 access"
                    },
                    {
                        "title": "Intelligent monitoring of cluster performance and health indicators, and setting of alarms to facilitate users' understanding of system status"
                    },
                    {
                        "title": "Support logging and user statistics, which can be calculated based on file system and resource conditions. Support predictive analysis of system capacity and performance, and hardware reading and writing"
                    }
                ]
            } else if (this.activeIndex == 12) {
                this.tableData12 = [
                    {
                        "title": "Core switch:"
                    },
                    {
                        "title": "S12500G-AF Intelligent Fusion Core Switch"
                    },
                    {
                        "title": "S10500 series core switch"
                    },
                    {
                        "title": "Convergence switch:"
                    },
                    {
                        "title": "H3C S7500 series high-end multi-service routing switch"
                    },
                    {
                        "title": "H3C S7600 series operational grade high-end routing switch"
                    },
                    {
                        "title": "H3C S6500 Series 10 Gigabit Layer 3 Switch"
                    },
                    {
                        "title": "H3C S5500 Series Ethernet Switch"
                    },
                    {
                        "title": "Access switch:"
                    },
                    {
                        "title": "H3C S5800 series switch"
                    },
                    {
                        "title": "H3C S5500 Series Ethernet Switch"
                    },
                    {
                        "title": "H3C WiNet Smart Series Ethernet Switch"
                    },
                    {
                        "title": "H3C S5170 Series Ethernet Switch"
                    },
                    {
                        "title": "H3C S5130 Series Ethernet Switch"
                    },
                    {
                        "title": "... ... "
                    }
                ]
            }
        },
        onZhList() {
            if (this.activeIndex == 1) {
                this.tableData1 = [
                    { title: '處理器', content: '支持多達2顆英特爾 ® 至强 ® 第三代可擴展處理器或瀾起津逮 ® 處理器系列，單顆多達40個覈心，最大功率270W' },
                    { title: '晶片組', content: '英特爾 ®  C621A' },
                    { title: '記憶體', content: '支持多達32個DDR4記憶體，速率最高支持3200MT/s，支持RDIMM或LRDIMM，單顆處理器最大容量6TB支持多達16個英特爾 ® 傲騰 ® 持久記憶體PMem 200系列' },
                    { title: '存儲控制器', content: '標配板載陣列控制器，支持SATA RAID 0/1/10/5可選基於標準PCIe插槽的HBA卡和陣列卡' },
                    { title: 'FBWC', content: '可選支持高達8GB緩存，支持超級電容保護' },
                    { title: '存儲', content: '支持多達41個硬碟（37個2.5英寸硬碟，4個3.5英寸硬碟）支持多達20個3.5英寸硬碟（12個前置，4個內部擴展，4個後部擴展）及4個2.5寸硬碟（後部擴展）支持多達37個2.5英寸硬碟（25個前置，8個內部擴展，4個後部擴展）支持SAS/SATA HDD/SSD硬碟； 支持前置/內寘NVMe硬碟，支持多達32個NVMe硬碟插槽，支持PCIe NVMe存儲加速卡支持SATA和PCIe M.2選件，支持2個Micro SD卡套件' },
                    { title: '網絡', content: '板載1個1Gbps專用管理網口可選多達2個OCP 3.0網卡，可選擴展4 × 1GE電口或2 × 10GE電口/光口或2 × 25GE光口可選基於標準PCIe插槽的網路介面卡，支持1/10/25/40/100/200 GE網卡，IB卡' },
                    { title: '擴展插槽', content: '支持多達14個PCIe 4.0標準插槽和1個OCP 3.0插槽（PCIe 4.0速率）' },
                    { title: '介面', content: '標配1個前置VGA，1個後置VGA和1個串口，6個USB 3.0（2前置，2後置，2內寘），1個前置專用管理介面' },
                    { title: 'GPU支持', content: '支持多達4個雙寬GPU卡或14個單寬GPU卡' },
                    { title: '光碟機', content: '支持外置光碟機' },
                    { title: '管理', content: 'HDM無代理管理工具（帶獨立管理埠）和H3C iFIST/FIST管理軟體，支持LCD可觸摸智慧管理模塊，支持64M本地顯存可選U-Center資料中心管理平臺' },
                    { title: '安全性', content: '支持安全主機殼，TCM/TPM安全模塊，雙因素認證' },
                    { title: '電源和散熱', content: '可選白金級550W/800W/850W/1200W/1300W/1600W/2000W 1+1冗餘電源，可選鈦金級電源可選800W負48V/336V直流電源模塊，支持1+1冗餘支持熱插拔冗餘風扇' },
                    { title: '認證', content: '支持CCC，SEPA等認證' },
                    { title: '工作溫度', content: '5℃- 45℃（工作溫度支持受不同配寘影響，詳情請參攷詳細產品技術文檔描述）' },
                    { title: '外形', content: '2U主機殼' },
                    { title: '主機殼尺寸', content: '87.5mm（高）*445.4mm（寬）*748mm（深）（不含安全面板）87.5mm（高）*445.4mm（寬）*776mm（深）（含安全面板）' },
                    { title: '保修', content: '3年5 × 9，下一工作日響應（NBD）' },
                ]
            } else if (this.activeIndex == 2) {
                this.tableData2 = [
                    { title: '處理器', content: '支持多達2顆英特爾 ® 至强 ® 可擴展家族處理器或瀾起津逮 ® 處理器系列，單顆多達28個覈心，最大功率205W' },
                    { title: '晶片組', content: '英特爾 ® C622' },
                    { title: '記憶體', content: '支持多達24個DDR4記憶體插槽，速率最高支持2933MT/s，支持RDIMM或LRDIMM，單顆處理器最大容量3TB  支持多達12個英特爾 ® 傲騰 ™ 資料中心級持久記憶體（DCPMM）' },
                    { title: '存儲控制器', content: '標配板載陣列控制器，支持SATA RAID 0/1/10/5可選基於陣列卡專用插槽的HBA卡，支持SATA/SAS RAID 0/1/10可選基於陣列卡專有插槽的陣列卡，支持RAID0/1/10/5/6/50/60/1E可選基於標準PCIe插槽的HBA卡和陣列卡' },
                    { title: 'FBWC', content: '可選支持高達8GB緩存，支持超級電容保護' },
                    { title: '存儲', content: '支持多達20個3.5英寸硬碟，4個2.5英寸硬碟（12個前置，4個內部擴展，8個後部擴展）支持多達37個2.5英寸硬碟，3個3.5英寸硬碟（25個前置，8個內部擴展，7個後部擴展）支持SAS/SATA HDD/SSD硬碟，支持前置/內寘NVMe硬碟，支持多達32個NVMe硬碟插槽支持SATA M.2選件' },
                    { title: '網絡', content: '板載1個1Gbps管理網口可選通過mLOM擴展4 × 1GE電口或2 × 10GE電口/光口可選基於標準PCIe插槽的網路介面卡' },
                    { title: '擴展插槽', content: '多達10個PCIe 3.0可用插槽（包含1個陣列卡專用插槽和1個網卡專用插槽）' },
                    { title: '介面', content: '可選前置VGA，標配後置VGA和串口，5個USB 3.0（1前置，2後置，2內寘），可選1個USB 2.0和2個Micro SD卡套件' },
                    { title: 'GPU支持', content: '支持多達3個雙寬GPU卡或8個單寬GPU卡' },
                    { title: '光碟機', content: '支持外置光碟機，部分機型支持內置光碟機' },
                    { title: '管理', content: 'HDM無代理管理工具（帶獨立管理埠）和H3C FIST管理軟體，支持16M本地顯存' },
                    { title: '安全性', content: '支持主機殼入侵偵測，TCM/TPM安全模塊，可選配寘PCIe防護模塊，提供防火牆、IPS、防病毒和QoS等防護功能' },
                    { title: '電源和散熱', content: '可選白金級別550W / 800W / 850W / 1200W / 1600W 1+1冗餘電源，可選鈦金級別1+1冗餘電源可選800W負48V / 336V直流電源模塊，支持1+1冗餘支持熱插拔冗餘風扇' },
                    { title: '認證', content: '支持CCC，CECP，SEPA，CE，CB等認證' },
                    { title: '工作溫度', content: '5℃- 50℃（工作溫度支持受不同配寘影響，詳情請參攷詳細產品技術文檔描述）' },
                    { title: '外形', content: '2U主機殼' },
                    { title: '主機殼尺寸', content: '87.5mm（高）* 445.4mm（寬）* 748mm（深）（不含安全面板）87.5mm（高）* 445.4mm（寬）* 771mm（深）（含安全面板）' },
                    { title: '保修', content: '3年5 × 9，下一工作日響應（NBD）' },
                ]
            } else if (this.activeIndex == 3) {
                this.tableData3 = [
                    { title: '處理器', content: '支持多達2顆英特爾 ® 至强 ® 可擴展家族處理器或瀾起津逮 ® 處理器系列，單顆多達28個覈心，最大功率205W' },
                    { title: '記憶體', content: '支持多達24個DDR4記憶體，速率最高支持2933MT/s，支持RDIMM或LRDIMM，單顆處理器最大容量3TB' },
                    { title: '永久性記憶體', content: '支持12個NVDIMM永久性記憶體，最大容量192GB，支持HPE DC永久記憶體，最大容量6TB' },
                    { title: '存儲控制器', content: '標配板載陣列控制器，支持SATA RAID 0/1/10/5支持HPE智慧存儲SR100i可選基於陣列卡專用插槽的HBA卡，支持SATA/SAS RAID 0/1/10/5可選基於陣列卡專有插槽的Smart Array系列陣列卡，支持SATA/SAS RAID0/1/10/5/6/50/60/ 1 ADM可選基於標準PCIe插槽的HBA卡和Smart Array陣列卡支持4GB FBWC' },
                    { title: '存儲', content: '支持多達20個3.5英寸硬碟，4個2.5英寸硬碟（12個前置，4個內部擴展，8個後部擴展）支持多達37個2.5英寸硬碟，3個3.5英寸硬碟（25個前置，8個內部擴展，7個後部擴展）支持SAS/SATA HDD/SSD硬碟，支持前置/內寘NVMe硬碟，支持多達32個NVMe硬碟插槽支持SATA M.2選件' },
                    { title: '網絡', content: '板載4口千兆網路介面卡/網卡可選NC型號不含板載網絡控制器可選FlexibleLOM網路介面卡可選基於標準PCIe插槽的網路介面卡' },
                    { title: '擴展插槽', content: '標配3個PCIe 3.0可用插槽，支持多達8個PCIe 3.0可用插槽' },
                    { title: '介面', content: '可選前置VGA和串口，標配後置VGA 5個USB 3.0（1前置，2後置，2內寘），可選2個Micro SD卡' },
                    { title: 'GPU支持', content: '多達7個單寬GPU卡或3個雙寬GPU卡' },
                    { title: '光碟機', content: '支持外置光碟機； 部分機型支持內置光碟機' },
                    { title: '管理', content: '標配iLO標準版，可選iLO高級版和OneView高級版' },
                    { title: '電源和散熱', content: '可選500W/800W/1600W 1 + 1熱拔插冗餘電源，最高支持96%鈦金，可支持6個熱插拔冗餘風扇' },
                    { title: '主機殼尺寸', content: '87.3mm（高）x 445.4mm（寬）x 679.4mm（深）（2.5英寸硬碟機型）87.3mm（高）x 445.4mm（寬）x 730.2mm（深）（3.5英寸硬碟機型）' },
                    { title: '保修', content: '通路銷售預配寘（BTO）機型3年5 × 9下一工作日響應項目銷售按單配寘（CTO）機型3年7 × 24 × 4小時服務，包含基礎上門安裝服務' },
                ]
            } else if (this.activeIndex == 4) {
                this.tableData4 = [
                    { title: '處理器', content: '4顆英特爾 ®  至强 ®  可擴展處理器，最多28個內核，最大功率205W' },
                    { title: '記憶體', content: '48根HPE DDR4智慧記憶體，最高速率2933MT/s，支持RDIMM或LRDIMM' },
                    { title: '永久性記憶體', content: '支持24個NVDIMM永久記憶體，支持24根英特爾 ® 傲騰 ™ 資料中心級持久記憶體（DCPMM）' },
                    { title: '存儲控制器', content: 'HPE Smart Array S100i或HPE智慧陣列控制器，具體取決於型號，支持最高4GB緩存支持Raid 0/1（ADM）/10（ADM）/5/50/6/6' },
                    { title: '存儲', content: '最多支持48個SFF硬碟，支持SATA/SAS/SSD包括支持20個NVMe SSD硬碟' },
                    { title: '網絡', content: '選配的FlexibleLOM，支持1Gb/10Gb/25Gb，可選PCIe網卡可支持最高100Gb網絡' },
                    { title: '擴展插槽', content: '最多16個全高PCIe插槽，支持4個雙寬GPU' },
                    { title: '介面', content: '9個USB埠（5個3.0，4個2.0，其中2個可選），2個視頻埠（1個可選），1個串口，1個MicroSD，支持雙MicroSD組件' },
                    { title: '風扇', content: '12（11+1）熱插拔冗餘標準' },
                    { title: '電源', content: '最多4個HPE靈活插槽電源支持240VDC高壓直流，具體取決於型號' },
                    { title: '環境', content: 'ASHRAE A3和A4（有限配寘），標準支持10℃~ 35℃，A3: 5 ~ 40℃； A4: 5 ~ 45℃' },
                    { title: '外形  （寬x深x高）', content: '44.55×75.18×17.48cm' },
                    { title: '重量', content: '滿配最大51.71kg' },
                    { title: '管理', content: '標配iLO標準版，可選iLO高級版和OneView高級版' },
                    { title: '保修', content: '通路銷售預配寘（BTO）機型3年5 × 9下一工作日響應項目銷售按單配寘（CTO）機型3年7 × 24 × 4小時服務，包含基礎上門安裝服務' },
                ]
            } else if (this.activeIndex == 8) {
                this.tableData8 = [{
                    "title": "硬碟   P07924-B21-X HPE 480GB SATA MU LFF SC DS SSD"
                },
                {
                    "title": "硬碟   P07928-B21-X HPE 960GB SATA MU LFF SCC DS SSD"
                },
                {
                    "title": "硬碟   P09691-B21-X HPE 960GB SATA RI LFF LPC DS SSD"
                },
                {
                    "title": "硬碟   P09687-B21-X HPE 480GB SATA RI LFF SCC DS SSD"
                },
                {
                    "title": "硬碟   P09687-B21-大单拆机 HPE 480GB SATA RI LFF SCC DS SSD"
                },
                {
                    "title": "硬碟   P19974-B21-X HPE 480GB SATA RI LFF LPC SSD 固態硬碟(G10 PLUS)"
                },
                {
                    "title": "硬碟   P09685-B21-X HPE 240GB SATA RI SFF RW DS SSD"
                },
                {
                    "title": "硬碟   P47810-B21-X HPE 480GB SATA RI SFF SC PM893 SSD 固態硬碟"
                },
                {
                    "title": "硬碟 P47811-B21-X HPE 960GB SATA RI SFF SC PM893 SSD 固態硬碟"
                },
                {
                    "title": "硬碟   P04560-B21-X HPE 480GB SATA RI SFF SC DS SSD"
                },
                {
                    "title": "硬碟   P04564-B21-X HPE 960GB SATA RI SFF SC DS SSD"
                },
                {
                    "title": "硬碟   P18422-B21-X HPE 480GB SATA RI SFF SC MV SSD"
                },
                {
                    "title": "硬碟   P18424-B21-X HPE 960GB SATA RI SFF SC MV SSD"
                },
                {
                    "title": "硬碟   P06200-B21-X HPE 3.84TB SATA RI SFF SC DS SSD(SK晶片)"
                },
                {
                    "title": "HP硬碟   P04570-B21 HPE 3.84TB SATA 6G RI SFF (2.5in) SC DS SSD"
                },
                {
                    "title": "硬碟   P13660-B21-X HPE 960GB SATA MU SFF SC DS SSD"
                },
                {
                    "title": "硬碟 P18434-B21-X HPE 960GB SATA MU SFF SC MV SSD"
                },
                {
                    "title": "硬碟   P18432-B21-X HPE 480GB SATA MU SFF SC MV SSD"
                },
                {
                    "title": "硬碟 P36997-B21-X HPE 960GB SAS RI SFF SC VS MV SSD"
                },
                {
                    "title": "硬碟 P19905-B21-X HPE 1.92TB SAS RI SFF SC SSD"
                },
                {
                    "title": "硬碟   P37001-B21-X HPE 3.84TB SAS RI SFF SC VS MV SSD 固態硬碟"
                },
                {
                    "title": "硬碟   P19907-B21-X HPE 3.84TB SAS RI SFF SC SSD"
                },
                {
                    "title": "硬碟   P37003-B21-X-大单选件 HPE 7.68TB SAS RI SFF SC VC MV SSD"
                },
                {
                    "title": "硬碟   P21125-B21-X HPE 400GB SAS WI SFF SC SSD"
                },
                {
                    "title": "硬碟 P21127-B21-X HPE 800GB SAS WI SFF SC SSD"
                },
                {
                    "title": "硬碟   P21127-B21-C HPE 800GB SAS WI SFF SC SSD"
                },
                {
                    "title": "硬碟   P09102-B21-X HPE 1.6TB SAS WI SFF SC DS SSD"
                },
                {
                    "title": "硬碟   P37005-B21-X HPE 960GB SAS MU SFF SC VS MV SSD 固態硬碟"
                },
                {
                    "title": "硬碟   P21133-B21-X HPE 1.6TB SAS MU SFF SC SSD"
                },
                {
                    "title": "硬碟   P19913-B21-C HPE 800GB SAS MU SFF SC SSD"
                },
                {
                    "title": "硬碟 P26934-B21-X HPE 1.6TB NVME MU HH PM1735 SSD(PCI-E)"
                },
                {
                    "title": "硬碟   P19915-B21-大单盒包 HPE 1.6TB SAS MU SFF SC SSD"
                },
                {
                    "title": "硬碟   P13668-B21-X HPE 800GB NVME X4 MU SFF SCN DS SSD"
                },
                {
                    "title": "硬碟   P13670-B21-X HPE 1.6TB NVME X4 MU SFF SCN DS SSD"
                },
                {
                    "title": "硬碟 P40554-B21-X HPE 1.92TB SATA VRO SFF BC 5210 SSD固态硬盘(G10 PLUS)"
                },
                {
                    "title": "硬碟   P44007-B21-X HPE 480GB SATA RI SFF BC PM893 SSD 固態硬碟(G10 PLUS)"
                },
                {
                    "title": "硬碟 P44008-B21-X HPE 960GB SATA RI SFF BC PM893 SSD 固態硬碟(G10 PLUS)"
                }]
            } else if (this.activeIndex == 9) {
                this.tableData9 = [{
                    "title": "應用加速"
                },
                {
                    "title": "H3C UniStor CF2000的效能超過20萬IOPS，用戶應用程序加速成本在可承受範圍內。"
                },
                {
                    "title": "無經驗要求"
                },
                {
                    "title": "H3C UniStor CF2000易於安裝，易於使用，易於維護，無需存儲方面的專業知識。 自動分層可動態響應工作負載變化，囙此不必人工干預"
                },
                {
                    "title": "通過擴展的數據保護功能來保持業務運行"
                },
                {
                    "title": "新型虛擬化快照科技使數據保護和即時恢復成為可能。"
                },
                {
                    "title": "使用FC或iSCSI進行遠程複製，降低了災難恢復成本。"
                },
                {
                    "title": "使現在和未來實現靈活增長"
                },
                {
                    "title": "數據原位陞級為驅動器投資提供了保護，降低了數據遷移風險。"
                },
                {
                    "title": "客戶可以利用SSD、企業級或Midline SAS驅動器的任意組合開始小型化和規模化部署。"
                }]
            } else if (this.activeIndex == 10) {
                this.tableData10 = [
                    {
                        "title": "新功能"
                    },
                    {
                        "title": "• 支持閃存介質的重複數據删除功能，進一步提高存儲容量的利用效率"
                    },
                    {
                        "title": "• SmartSAN功能支持SAN Zoning自動化配寘，不需要在配寘主機和卷之前提前配寘SAN Zoning，自動發現和創建由存儲目標埠管理的SAN Zoning"
                    },
                    {
                        "title": "• 支持同系列的中端入門級、中端企業級和高端企業級產品的三數據中心存儲級容灾科技，每個控制器自帶1個IP災備複製介面。 災備科技可以與精簡配寘、非同步快照科技結合，降低連結複製成本，最新版本更可以支持統一管理的SAN和NAS雙活+三中心災備的解決方案"
                    },
                    {
                        "title": "• 支持精細的QoS控制，可以針對每一個卷進行IOPS，頻寬和時延的設定，從而能够確保為您的應用、工作負載和租戶帶來可預測的服務級別，可控制應用的時延小於0.5ms"
                    },
                    {
                        "title": "先進的架構使得H3C CF系列存儲脫穎而出"
                    },
                    {
                        "title": "三層虛擬化架構提供的高性能和自動優化可以輕鬆應對企業級資料中心對云計算、虛擬化和資料中心綜合對於混合負載的要求。 可以從兩個控制器擴展到多個控制器、控制器之間以PCI-E匯流排互聯提供橫向和縱向三維擴展，支持超過32TB的緩存，優化IO效能，降低訪問延遲。 控制器引擎相互間完全物理獨立，控制器引擎所有的處理器/緩存/前端卡/後端卡等覈心組件完全私有獨立。 在同一架構下融合了SAN，NAS和Object Storage，滿足多種不同的訪問需求。 為閃存優化的架構，實現了快閃記憶體盤和機械硬碟的融合、提供了閃存數據訪問的優化、同時提供了閃存二級自我調整快取記憶體和數據自動分層功能。"
                    },
                    {
                        "title": "高可用特性使得用戶可以高枕無憂"
                    },
                    {
                        "title": "高達99.9999%的高可用性，T10-PI端到端的數據一致性校驗，四控的緩存保持功能，跨磁片櫃的RAID可以實現盤籠級別的安全保障，尅隆、快照和遠程複製軟件以及融合的備份功能可以實現進一步的數據保護"
                    },
                    {
                        "title": "簡便高效、降低用戶的總體成本"
                    },
                    {
                        "title": "精簡配寘和重複數據删除功能可以降低用戶的容量高達75%。 圖形化的管理介面和報表功能，SAN網絡自動配寘、快速安裝嚮導和智慧自動優化功能可以降低用戶的管理時間高達90%"
                    },
                    {
                        "title": "提供所有企業級存儲功能"
                    },
                    {
                        "title": "不僅提供了傳統企業級存儲的尅隆、快照和遠程數據複製的功能，還為新一代企業資料中心提供了VMWare VAAI，VASA的集成、Microsoft Hyper-V的集成以及Open Stack的集成，同時還提供了快速RAID恢復、數據優化軟體、完善的Qos控制、存儲分區、存儲集羣、三數據中心容灾、陣列間高可用和線上數據遷移等功能"
                    },
                    {
                        "title": "通過H3C CF系列Peer Motion功能在不加額外閘道的情况下可以實現和H3C CF高端型號存儲組成存儲聯邦集羣，數據可以在多臺存儲之間按照效能、容量等策略進行線上數據遷移，對於主機平臺透明"
                    },
                    {
                        "title": "支持雲備份特性，支持將數據直接備份到公有雲或私有雲中"
                    },
                    {
                        "title": "優勢"
                    },
                    {
                        "title": "1.融合存儲架構：可以在一個存儲上同時實現SAN，NAS和Object Storage功能，不同型號的H3C CF存儲之間可以實現同步和异數據複製，不同型號的CF設備之間可以組成存儲聯邦"
                    },
                    {
                        "title": "2.CPU+ASIC晶片：先進的第5代ASIC晶片以硬體加速的管道實現精簡配寘、重删和RAID運算等功能，可以輕鬆應對虛擬化環境和云計算中的混合IO負載，可使事物密集型和吞吐密集型工作負載同時運行於相同的存儲資源上而不會發生資源爭用現象"
                    },
                    {
                        "title": "3.真正的多控制系統：多控制器架構，多個控制器之間採用高頻寬、低延時PCI-E匯流排點對點全網狀直接互聯，多個控制器可以併發訪問同一個LUN空間，保證了效能隨著控制器數據的增長而線性增長； 並且多控情况下，在多個控制器故障的時候能够保持存儲的高性能運行"
                    },
                    {
                        "title": "4.存儲內部底層虛擬化技術：保證了存儲系統的高IO效能，不會出現熱點硬碟，在硬碟故障的情况下能够多對多高速重建，同一塊硬碟上可以同時存在RAID0/1/5/6/10/50/60等不同的RAID類型"
                    },
                    {
                        "title": "5.高可用性：高達99.9999%的可用性，提供從主機HBA埠到存儲陣列硬碟的T10-PI一致性數據檢測保護，保障數據的完整性； 同時具備數據高可用功能，提供基於存儲的數據副本保護功能，數據寫入存儲時可根據策略創建2-4個數據副本，保護資料安全； 另外，存儲系統支援至少一個硬碟擴展櫃掉電或故障時數據不遺失，應用不中斷，提供擴展櫃級的數據保護機制"
                    },
                    {
                        "title": "6.高適用性：可創建不少於65536個虛擬卷，以及不少於16000個主機連接，適用於各種已存在的IT環境"
                    },
                    {
                        "title": "7.企業級功能：擁有强大的快照、尅隆、精簡配寘，重删、壓縮、自動分層、一鍵RAID類型轉換、存儲聯邦、異構存儲數據遷移、閃備數據保護解決方案和同非同步容灾、3DC容灾，雙活，雙活+3DC等企業級功能"
                    },
                    {
                        "title": "8.存儲異構虛擬化功能：實現CF系列存儲對協力廠商不同廠商存儲陣列的異構接管，支持主流存儲廠商產品，實現數據的遷移等。"
                    }
                ]
            } else if (this.activeIndex == 11) {
                this.tableData11 = [
                    {
                        "title": "分佈式融合架構"
                    },
                    {
                        "title": "H3C UniStor X10000採用全分佈式融合架構，為存儲系統的高性能、高擴展、安全可靠、自動化運維提供了有力保證。"
                    },
                    {
                        "title": "同時支持塊、檔案、對象與大資料存儲"
                    },
                    {
                        "title": "支持大資料存儲功能，支持Hadoop、Hbase、Hive、Spark、Impala等組件，並支持追加寫語義"
                    },
                    {
                        "title": "分佈式對稱架構，不需要單獨的中繼資料服務器"
                    },
                    {
                        "title": "分佈式全域緩存，有效提高集羣讀寫效能"
                    },
                    {
                        "title": "支持Intel晶片平臺與海光晶片平臺"
                    },
                    {
                        "title": "開放虛擬機器架構，支持在節點內部署廠商自研或協力廠商流媒體軟件。"
                    },
                    {
                        "title": "强大的線性擴展能力"
                    },
                    {
                        "title": "可橫向擴展至8192個節點，支撐業務靈活發展"
                    },
                    {
                        "title": "效能和容量隨節點數和集羣規模線性增長"
                    },
                    {
                        "title": "高可靠"
                    },
                    {
                        "title": "多副本保證數據可靠性，支持2-8個副本靈活配寘，比如三副本只有3份數據同時遺失時用戶數據才會真正遺失，資料存儲的持久性"
                    },
                    {
                        "title": "支持N+1到N+4的不同糾删碼級別，可基於資源池和目錄設定"
                    },
                    {
                        "title": "全面的數據保護和容灾能力，支持複製、快照、尅隆、拷貝、故障域、保護域等科技"
                    },
                    {
                        "title": "數據的持久性≥99.99999999999%（13個9）"
                    },
                    {
                        "title": "高可用"
                    },
                    {
                        "title": "採用完全冗餘組網，無單點故障，硬碟或節點損壞時保證業務不中斷、應用無感知"
                    },
                    {
                        "title": "硬碟或節點故障時自動重構，可調整重構優先順序"
                    },
                    {
                        "title": "支持線上不停機擴容，新增或删除節點、硬碟不影響業務正常運行，支持集羣自動數據均衡"
                    },
                    {
                        "title": "數據的可用性≥99.99995%"
                    },
                    {
                        "title": "易維護"
                    },
                    {
                        "title": "集羣快速部署，支持批量部署、配寘引導、一鍵陞級"
                    },
                    {
                        "title": "依託監控報警系統，快速界定問題、排查故障，允許用戶定制數據分佈策略，支持故障域隔離"
                    },
                    {
                        "title": "易管理"
                    },
                    {
                        "title": "中文視覺化操作管理平臺，同時支持IPv4和IPv6接入"
                    },
                    {
                        "title": "智慧監控集羣的效能和健康名額並設定告警，方便用戶瞭解系統狀態"
                    },
                    {
                        "title": "支持日誌和用戶統計，可以按檔案系統、資源情况的統計，支持系統容量和效能的預測分析理硬體進行讀寫"
                    }
                ]
            } else if (this.activeIndex == 12) {
                this.tableData12 = [
                    {
                        "title": "覈心交換機："
                    },
                    {
                        "title": "S12500G-AF智慧融合覈心交換機"
                    },
                    {
                        "title": "S10500系列覈心交換機"
                    },
                    {
                        "title": "彙聚交換機："
                    },
                    {
                        "title": "H3C S7500系列高端多業務路由交換機"
                    },
                    {
                        "title": "H3C S7600系列運營級高端路由交換機"
                    },
                    {
                        "title": "H3C S6500系列萬兆三層交換機"
                    },
                    {
                        "title": "H3C S5500系列乙太網交換機"
                    },
                    {
                        "title": "接入交換機："
                    },
                    {
                        "title": "H3C S5800系列交換機"
                    },
                    {
                        "title": "H3C S5500系列乙太網交換機"
                    },
                    {
                        "title": "H3C WiNet智慧系列乙太網交換機"
                    },
                    {
                        "title": "H3C S5170系列乙太網交換機"
                    },
                    {
                        "title": "H3C S5130系列乙太網交換機"
                    },
                    {
                        "title": "... ... "
                    }
                ]
            }
        },
    }
};
</script>
<style scoped lang="scss">
@media only screen and (max-width: 750px) {
    .p-btn {
        div {
            font-size: 16px;
            line-height: 32px;
            cursor: pointer;
        }
    }

    .title {
        display: flex;
        align-items: center;

        h3 {
            font-size: 18px;
            line-height: 40px;
            margin-left: 6px;
            font-weight: normal;
        }

        .span {
            height: 16px;
            width: 4px;
            background-color: #1b5fc1;

        }
    }

    .product-illustrate {
        width: 100%;
        margin: 20px 0;

        .product-show {
            p {
                text-indent: 2em;
                font-size: 14px;
                line-height: 24px;
            }

            .spec {
                font-size: 16px;
                margin: 30px 0;
                font-weight: bold;
            }
        }
    }

    .wrap {
        padding: 80px 20px 20px 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;

        .product-box {

            .product-right {
                border-left: 1px solid #ececec;

                ul li {
                    float: left;
                    margin: 15px 40px 0 20px;
                    border: #e4e4e4 solid 1px;
                    display: inline;
                    padding: 10px 20px;
                    font-size: 16px;
                }
            }

            .product-left {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .product-content {

                    h3 {
                        color: #1b5fc1;
                        font-size: 18px;
                        font-weight: bold;
                        margin-top: 20px;
                        text-align: center;
                    }

                    .product-sub-title {
                        font-size: 14px;
                        margin-top: 10px;
                        text-align: center;
                    }

                    .product-btn {
                        background-color: #1b5fc1;
                        border-color: #1b5fc1;
                        line-height: 10px;
                        margin-top: 10px;
                        display: block;
                        margin: 10px auto;
                    }
                }

                .product-img {
                    width: 200px;
                    height: 200px;
                    overflow: hidden;
                    border: 1px solid #a3a3a3;
                    box-shadow: 0 0 10px #c5c5c5;

                    img {
                        width: 100%;
                    }
                }
            }


        }
    }
}

@media only screen and (min-width:751px) {
    .p-btn {
        div {
            font-size: 16px;
            line-height: 32px;
            cursor: pointer;
        }
    }

    .title {
        display: flex;
        align-items: center;

        h3 {
            font-size: 18px;
            line-height: 40px;
            margin-left: 6px;
            font-weight: normal;
        }

        .span {
            height: 16px;
            width: 4px;
            background-color: #1b5fc1;

        }
    }

    .product-illustrate {
        margin: 40px 0;

        .product-show {
            p {
                text-indent: 2em;
                font-size: 16px;
                line-height: 26px;
            }

            .spec {
                font-size: 16px;
                margin: 30px 0;
                font-weight: bold;
            }
        }
    }

    .wrap {
        padding: 180px 60px 60px 60px;
        box-sizing: border-box;

        .product-box {
            display: flex;

            .product-right {
                width: 20%;
                border-left: 1px solid #ececec;
                padding-left: 24px;

                ul li {
                    float: left;
                    margin: 15px 40px 0 20px;
                    border: #e4e4e4 solid 1px;
                    display: inline;
                    padding: 10px 20px;
                    font-size: 16px;
                }
            }

            .product-left {
                display: flex;
                width: 80%;

                .product-content {
                    margin-left: 40px;
                    margin-top: 20px;

                    h3 {
                        color: #1b5fc1;
                        font-size: 24px;
                        font-weight: bold;

                    }

                    .product-sub-title {
                        font-size: 16px;
                        margin: 30px 0 90px;
                    }

                    .product-btn {
                        background-color: #1b5fc1;
                        border-color: #1b5fc1;
                        width: 240px;
                        line-height: 30px;
                    }
                }

                .product-img {
                    width: 420px;
                    height: 420px;
                    overflow: hidden;
                    border: 1px solid #a3a3a3;
                    box-shadow: 0 0 20px #c5c5c5;
                    display: flex;
                    justify-content: center;
                    align-items: center;


                    img {
                        width: 100%;
                    }
                }
            }


        }
    }
}
</style>